import React, { FC } from 'react';
import {
  Filter,
  ReferenceInput,
  SelectInput,
  DateInput,
  TextInput,
  FilterProps,
} from 'react-admin';
import { LazyReferenceInput } from 'components/LazyAutoCompleteInput';
import { LazyReferenceArrayInput } from 'components/LazyReferenceArrayInput';
import { SupervisorReferenceInput } from 'components/SupervisorReferenceInput';
import { PhaseSelectInput } from '../../rm-master-sheet/components/PhaseSelectInput';

export const ProdPayMasterSheetFilter: FC<FilterProps> = props => {
  const subdivisionId = (props as any).filterValues?.subdivisionId;

  return (
    <Filter {...props}>
      <SupervisorReferenceInput source="supervisorUserIds||$cont" alwaysOn />
      <TextInput
        label="Lot"
        source="jobLot||$eq"
        alwaysOn
        resettable
        data-cy="ProdPayMasterSheetSheetFilterLot"
      />
      <TextInput
        label="Block"
        source="jobBlock||$eq"
        alwaysOn
        resettable
        data-cy="ProdPayMasterSheetSheetFilterBlock"
      />
      <LazyReferenceInput
        label="Builder"
        source="builderId"
        reference="builder"
        resettable
        data-cy="ProdPayMasterSheetFilterBuilder"
        allowEmpty={false}
        filterToQuery={value => (value ? { name: value } : {})}
        sort={{ field: 'name', order: 'ASC' }}
        optionText="name"
        optionValue="id"
      />
      <LazyReferenceInput
        label="Subdivision"
        source="subdivisionId"
        reference="subdivision"
        data-cy="ProdPayMasterSheetFilterSubdivision"
        resettable
        allowEmpty={false}
        filterToQuery={value => (value ? { name: value } : {})}
        sort={{ field: 'name', order: 'ASC' }}
        optionText="name"
        optionValue="id"
      />
      <LazyReferenceInput
        label="Model"
        source="modelId"
        reference="model"
        resettable
        allowEmpty={false}
        data-cy="ProdPayMasterSheetFilterModel"
        key={`model-filter-${subdivisionId || 'all'}`}
        filterToQuery={value => {
          const filter: any = {};

          const currentSubdivisionId = (props as any).filterValues
            ?.subdivisionId;
          if (currentSubdivisionId) {
            filter.subdivisionId = currentSubdivisionId;
          }

          if (value) {
            filter.name = value;
          }

          return filter;
        }}
        sort={{ field: 'name', order: 'ASC' }}
        optionText="name"
        optionValue="id"
      />
      <LazyReferenceArrayInput
        label="Contractor"
        source="contractorId||$in"
        reference="contractor"
        data-cy="ProdPayMasterSheetFilterContractor"
        alwaysOn
      />
      <LazyReferenceInput
        label="Region"
        data-cy="ProdPayMasterSheetFilterRegion"
        source="regionId"
        reference="region"
        resettable
        allowEmpty={false}
        filterToQuery={value => (value ? { name: value } : {})}
        sort={{ field: 'name', order: 'ASC' }}
        optionText="name"
        optionValue="id"
      />
      <SelectInput
        label="Workflow"
        source="phaseStructureType||$eq"
        data-cy="ProdPayMasterSheetFilterWorkflow"
        choices={[
          { id: 'Drywall', name: 'Drywall' },
          { id: 'DrywallAndPaint', name: 'Drywall and Paint' },
        ]}
        allowEmpty={true}
        resettable
        emptyText="All"
        options={{
          SelectProps: { displayEmpty: true },
          InputLabelProps: { shrink: true },
        }}
      />
      <SelectInput
        label="Marked House"
        source="houseMarked"
        data-cy="ProdPayMasterSheetFilterMarkedHouse"
        choices={[
          { val: true, text: 'Yes' },
          { val: false, text: 'No' },
        ]}
        optionValue="val"
        optionText="text"
        allowEmpty={true}
        emptyText="All"
        resettable
      />
      <ReferenceInput
        label="Phase"
        data-cy="ProdPayMasterSheetFilterPhase"
        source="phaseId"
        reference="phase"
        perPage={Number.MAX_SAFE_INTEGER}
        resettable
        allowEmpty={false}
        sort={{ field: 'priority', order: 'ASC' }}
      >
        <PhaseSelectInput
          source="phaseId"
          label="Phase"
          applyPriorityFilter={false}
        />
      </ReferenceInput>
      <DateInput
        label="Completed On or After"
        source="dateApproved||$gte"
        data-cy="ProdPayMasterSheetFilterDateApprovedBegin"
      />
      <DateInput
        label="Completed On or Before"
        source="dateApproved||$lte"
        data-cy="ProdPayMasterSheetFilterDateApprovedEnd"
      />
      <DateInput
        label="Paid On or After"
        source="datePaid||$gte"
        data-cy="ProdPayMasterSheetFilterDatePaidBegin"
      />
      <DateInput
        label="Paid On or Before"
        source="datePaid||$lte"
        data-cy="ProdPayMasterSheetFilterDatePaidEnd"
      />
      <SelectInput
        source="isPaid"
        label="Status"
        data-cy="ProdPayMasterSheetFilterIsPaid"
        choices={[
          { val: true, text: 'Paid' },
          { val: false, text: 'Unpaid' },
        ]}
        emptyText="All"
        optionValue="val"
        optionText="text"
        alwaysOn
      />
    </Filter>
  );
};
